import { InjectionToken } from '@angular/core';

export interface CapicheLoggerConfig {
  envName: string;
}

export const CAPICHE_LOGGER_CONFIG = new InjectionToken<CapicheLoggerConfig>('CapicheLoggerConfig');
